<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<aside class="epicfm">
<p class="dedh"><span epub:type="pagebreak" id="page_vii">“My chutneys and kasaundies are, after all, connected to my nocturnal scribblings—by day amongst the pickle-vats, by night within these sheets, I spend my time at the great work of preserving. Memory, as well as fruit, is being saved from the corruption of the clocks.”</span></p>
<p class="ded">—Salman Rushdie, <em>Midnight’s Children</em><span epub:type="pagebreak" id="page_viii"></span></p>
</aside>
<div class="land40"><img alt="Image" src="images/f0vii-01.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pref00.vue?ede06552